import React, { useState, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";
import { db, auth } from "../firebase";
import { doc, getDoc, arrayUnion, updateDoc, setDoc } from "firebase/firestore";
// import CloseButton from 'react-bootstrap/CloseButton';
import Button from 'react-bootstrap/Button';
import NavBar from '../Components/NavBar';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ListGroup from 'react-bootstrap/ListGroup';
import EditLineup from '../Modules/EditPlayersNewGame';
import SubmitStats from '../Modules/SubmitStats';
import Globals from '../Globals';

const NewGame = () => {
    const { teamName } = useParams();
    const [battingOrder, setBattingOrder] = useState([])
    // const [tempPlayers, setTempPlayers] = useState(players);
    const [gameStats, setGameStats] = useState([]); 
    const [rbis, setRbis] = useState([]);
    const [average, setAverage] = useState([]);
    const [selectedPlayerIdx, setSelectedPlayerIdx] = useState(0);
    const [lineupToggle, setLineupToggle] = useState(true);
    const [popupToggle, setPopupToggle] = useState(false);
    const [secret, setSecret] = useState("");
    const goodButtons = [{ buttonText:"1st", playerOutcomes: "Single"}, { buttonText:"2nd", playerOutcomes: "Double"}, { buttonText:"3rd", playerOutcomes: "Triple"}, { buttonText:"Homerun", playerOutcomes: "Homerun"}]
    const badButtons = ["Out", "Strikeout", "No Bat"];
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [gameType, setGameType] = useState('regular');
    const [forceOutcome, setForceOutcome] = useState('auto');
    const [allPlayers, setAllPlayers] = useState();
    const [lineupCards, setLineupCards] = useState([]);
    const [ourScore, setOurScore] = useState(0);
    const [theirScore, setTheirScore] = useState(0);
    const [opponentTeamName, setOpponentTeamName] = useState("");
    const [saveGameResult, setSaveGameResult] = useState({
        show: false,
        success: false,
        message: ''
    });
    const [statsSubmitted, setStatsSubmitted] = useState(false);

    const prevBattingOrderRef = useRef([]);
    const validBattingOrder = battingOrder.filter(player => player && player.name);

    const gameHasStarted = validBattingOrder.length >= 3 && (
        gameStats.some(stats => stats.length > 0) ||
        rbis.some(r => r > 0) ||
        ourScore > 0 ||
        theirScore > 0
    );

    const safeSelectedPlayerIdx = validBattingOrder.length > 0
        ? Math.min(Math.max(selectedPlayerIdx, 0), validBattingOrder.length - 1)
        : 0;

    useEffect(() => {
        console.log("auth.currentUser", auth.currentUser);

        const func = async () => {
            const docRef = doc(db, "teams", teamName);
            const docSnap = await getDoc(docRef);
            if (!docSnap.exists()) {
                setData({ teamInfo: { players: [] } });
                setAllPlayers([]);
                setLoading(false);
                setAverage([]);
                setGameStats([]);
                setRbis([]);
                return;
            }

            const dbInfo = docSnap.data();
            const teamPlayersInfo = {
                teamInfo: dbInfo,
                dateCreated: Date.now(),
            };

            setData(teamPlayersInfo);
            const playerData = dbInfo.players || [];
            console.log('🎯 NewGame - playerData:', playerData);
            console.log('🎯 NewGame - playerData type:', typeof playerData, Array.isArray(playerData) ? 'ARRAY' : 'NOT ARRAY');

            setAllPlayers(playerData);
            setLoading(false);
            const averagesNeeded = [];
            const gameStatsNeeded = [];
            const rbisNeeded = [];

            console.log('🎯 NewGame - About to call forEach on playerData');
            playerData.forEach(() => {
                averagesNeeded.push([0, 0]);
                gameStatsNeeded.push([]);
                rbisNeeded.push(0);
            });

            setAverage(averagesNeeded);
            setGameStats(gameStatsNeeded);
            setRbis(rbisNeeded);
        }
        func();
    }, [teamName]);

    const handleRadioChange = (e) => {
        setSelectedPlayerIdx(Number(e.target.value));
    }

    const handleCompleteBatClick = (e, updatePoints = '') => {
        const idx = battingOrder.length > 0
            ? Math.min(Math.max(selectedPlayerIdx, 0), battingOrder.length - 1)
            : -1;

        if (idx < 0) return;
        const stat = e.target.value;

        if (goodButtons.some((elem) => elem.playerOutcomes === stat) || badButtons.includes(stat) || stat === 'No Bat') {
            const copiedStats = [...gameStats];
            if (!Array.isArray(copiedStats[idx])) copiedStats[idx] = [];
            copiedStats[idx].push(stat);
            setGameStats(copiedStats);

            if (stat !== 'No Bat') {
                const copiedAverage = [...average];
                if (!Array.isArray(copiedAverage[idx])) copiedAverage[idx] = [0, 0];
                copiedAverage[idx][1] = (copiedAverage[idx][1] || 0) + 1;

                if (goodButtons.some((elem) => elem.playerOutcomes === stat)) {
                    copiedAverage[idx][0] = (copiedAverage[idx][0] || 0) + 1;
                    // Auto-add score for home runs
                    if (stat === "Homerun") {
                        setOurScore(prev => prev + 1);
                    }
                }
                setAverage(copiedAverage);
            }
        }
        else if (stat === "RBI+" || (stat === "RBI-" && ((rbis && rbis[idx]) || 0) > 0)){
            const copiedRBIs = [...rbis];
            if (typeof copiedRBIs[idx] === 'undefined') copiedRBIs[idx] = 0;
            if (stat === "RBI+"){
                copiedRBIs[idx] += 1;
                if(updatePoints === 'add')
                    setOurScore(prev => prev + 1);
            }
            else{
                copiedRBIs[idx] -= 1;
                if(updatePoints === 'subtract')
                    setOurScore(prev => prev - 1);
            }

            setRbis(copiedRBIs);
        }
    }

    const handleDelete = () => {
        const idx = battingOrder.length > 0
            ? Math.min(Math.max(selectedPlayerIdx, 0), battingOrder.length - 1)
            : -1;
        if (idx < 0) return;

        const currGameStats = [...gameStats];
        const currAvgStats = [...average];
        if (!Array.isArray(currGameStats[idx])) return;
        const deletedStat = currGameStats[idx].pop();
        if (deletedStat){
            if (goodButtons.some((elem) => elem.playerOutcomes === deletedStat)){
                if (!Array.isArray(currAvgStats[idx])) currAvgStats[idx] = [0,0];
                currAvgStats[idx][0] = (currAvgStats[idx][0] || 0) - 1;
                // Auto-remove score if homerun is deleted
                if (deletedStat === "Homerun")
                    setOurScore(prev => prev - 1);
            }
            currAvgStats[idx][1] = Math.max(0, (currAvgStats[idx] && currAvgStats[idx][1]) ? currAvgStats[idx][1] - 1 : 0);

            setAverage(currAvgStats);
            setGameStats(currGameStats);
        }

    }

    const handleLineupForm = (e) => {
        e.preventDefault();
        Globals.toggleCB(setLineupToggle);
        setBattingOrder(lineupCards.filter(player => player && player.name));
    }

    useEffect(() => {
        if (gameHasStarted) {
            setLineupToggle(false);
        }
    }, [gameHasStarted]);

    // When the Edit Lineup modal opens, initialize lineupCards from the current battingOrder
    useEffect(() => {
        if (lineupToggle) {
            setLineupCards(battingOrder.slice());
        }
    }, [lineupToggle]);

    // Remap existing per-player arrays (average, gameStats, rbis) to the new battingOrder
    useEffect(() => {
        const prev = prevBattingOrderRef.current || [];
        // If there was no previous lineup, just initialize arrays to match new order
        const prevNames = prev.map(p => p.name);

        const newAverage = battingOrder.map((player) => {
            const idx = prevNames.indexOf(player.name);
            return (idx > -1 && average[idx]) ? average[idx] : [0, 0];
        });

        const newGameStats = battingOrder.map((player) => {
            const idx = prevNames.indexOf(player.name);
            return (idx > -1 && gameStats[idx]) ? gameStats[idx] : [];
        });

        const newRbis = battingOrder.map((player) => {
            const idx = prevNames.indexOf(player.name);
            return (idx > -1 && typeof rbis[idx] !== 'undefined') ? rbis[idx] : 0;
        });

        setAverage(newAverage);
        setGameStats(newGameStats);
        setRbis(newRbis);

        prevBattingOrderRef.current = battingOrder.slice();
    }, [battingOrder]);

    // Ensure selectedPlayerIdx is valid whenever the batting order changes
    useEffect(() => {
        if (!Array.isArray(validBattingOrder) || validBattingOrder.length === 0) {
            setSelectedPlayerIdx(0);
            return;
        }
        if (selectedPlayerIdx >= validBattingOrder.length) {
            setSelectedPlayerIdx(Math.max(0, validBattingOrder.length - 1));
        }
    }, [validBattingOrder, selectedPlayerIdx]);

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (gameHasStarted && !statsSubmitted) {
                e.preventDefault();
                e.returnValue = '';
                return '';
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [gameHasStarted, statsSubmitted]);
    
    const handleSubmitStatsForm = async (e) => {
        e.preventDefault();

        const currentUser = auth.currentUser;
        const currentUserEmail = currentUser?.email || null;
        const authorizedEmails = data.teamInfo?.authorizedEmails || [];

        if (!currentUser) {
            setSaveGameResult({
                show: true,
                success: false,
                message: 'You must be signed in to submit stats.'
            });
            return;
        }

        if (!authorizedEmails.includes(currentUserEmail)) {
            setSaveGameResult({
                show: true,
                success: false,
                message: `Signed-in email ${currentUserEmail} is not authorized for this team.`
            });
            return;
        }

        if (data.teamInfo.secret !== secret) {
            setSaveGameResult({
                show: true,
                success: false,
                message: 'Wrong team password'
            });
            return;
        }

        try {
            const currentYear = new Date().getFullYear();
            const docRef = doc(db, "teams", teamName);
            const sessionRef = doc(db, "teams", teamName, "allSeasons", currentYear.toString());
            const [docSnap, sessionSnap] = await Promise.all([getDoc(docRef), getDoc(sessionRef)]);

            const originalPlayerStats = docSnap.data().players;

            const updatedPlayers = originalPlayerStats.map((originalPlayerStat) => {
                const batter = battingOrder.find(bat => bat.name === originalPlayerStat.name);
                if (!batter) return originalPlayerStat;

                const prevStats = {
                    singles: originalPlayerStat.singles,
                    doubles: originalPlayerStat.doubles,
                    triples: originalPlayerStat.triples,
                    homeruns: originalPlayerStat.homeruns,
                    outs: originalPlayerStat.outs,
                    strikeouts: originalPlayerStat.strikeouts,
                    rbis: originalPlayerStat.rbis,
                    games: originalPlayerStat.games,
                };

                const idx = battingOrder.map(e => e.name).indexOf(batter.name);
                const playerGameStats = Array.isArray(gameStats[idx]) ? gameStats[idx] : [];
                playerGameStats.forEach((type) => {
                    if (type === "Single")
                        prevStats.singles += 1;
                    else if (type === "Double")
                        prevStats.doubles += 1;
                    else if (type === "Triple")
                        prevStats.triples += 1;
                    else if (type === "Homerun")
                        prevStats.homeruns += 1;
                    else if (type === "Strikeout")
                        prevStats.strikeouts += 1;
                    else if (type === "Out")
                        prevStats.outs += 1;
                });
                const playerRBIs = typeof rbis[idx] === 'number' ? rbis[idx] : 0;
                prevStats.rbis += playerRBIs;
                if (playerGameStats.length > 0) {
                    prevStats.games += 1;
                }
                return { ...originalPlayerStat, ...prevStats };
            });

            try {
                await updateDoc(docRef, { players: updatedPlayers });
            } catch (err) {
                console.error('SubmitStats failed updating team players:', err, { currentUserEmail, authorizedEmails, teamName });
                throw err;
            }

            let outcome = 1;
            if (forceOutcome === 'us') {
                outcome = 2;
            } else if (forceOutcome === 'them') {
                outcome = 0;
            } else if (ourScore > theirScore) {
                outcome = 2;
            } else if (ourScore < theirScore) {
                outcome = 0;
            }

            const sessionData = sessionSnap.exists() ? sessionSnap.data() : { games: [] };
            const gameNumber = calculateGameNumber(sessionData.games, gameType);

            const newGameData = {
                battingOrder: battingOrder.map(person => person.name),
                datePlayed: new Date(),
                isPlayoffs: gameType === "playoff",
                isPreSeason: gameType === "pre-season",
                opponentTeamName: opponentTeamName,
                ourScore: ourScore,
                outcome: outcome,
                theirScore: theirScore,
                gameNumber: gameNumber
            };

            try {
                if (sessionSnap.exists()) {
                    await updateDoc(sessionRef, { games: arrayUnion(newGameData) });
                } else {
                    await setDoc(sessionRef, { games: [newGameData] });
                }
            } catch (err) {
                console.error('SubmitStats failed updating season document:', err, { currentUserEmail, authorizedEmails, teamName });
                throw err;
            }

            setSaveGameResult({
                show: true,
                success: true,
                message: 'Stats have been successfully added'
            });
            setStatsSubmitted(true);
        } catch (error) {
            console.error('SubmitStats error:', error, { currentUserEmail, authorizedEmails, teamName });
            setSaveGameResult({
                show: true,
                success: false,
                message: error.code === 'permission-denied'
                    ? 'Permission denied: your account may not be authorized for this team or collection.'
                    : `Error updating document: ${error.message || error}`
            });
        } finally {
            setSecret("");
        }
    };

    const calculateGameNumber = (games = [], thisGameType) => {
        let gameTypeCounter = 0;
        const currentGames = Array.isArray(games) ? games : [];
        currentGames.forEach(sessionGame => {
            if ((thisGameType === "playoff" && sessionGame.isPlayoffs) ||
                (thisGameType === "pre-season" && sessionGame.isPreSeason) ||
                (thisGameType === "regular" && !sessionGame.isPreSeason && !sessionGame.isPlayoffs)) {
                gameTypeCounter++;
            }
        });
        return ++gameTypeCounter;
    }

    const goToPreviousBatter = () => {
        if (validBattingOrder.length === 0) return;
        setSelectedPlayerIdx(prev => {
            const current = Math.min(Math.max(prev, 0), validBattingOrder.length - 1);
            return current - 1 > -1 ? current - 1 : validBattingOrder.length - 1;
        });
    }

    const goToNextBatter = () => {
        if (validBattingOrder.length === 0) return;
        setSelectedPlayerIdx(prev => {
            const current = Math.min(Math.max(prev, 0), validBattingOrder.length - 1);
            return current + 1 < validBattingOrder.length ? current + 1 : 0;
        });
    }

    const getNext3Batters = (battingOrder, idx) => {
        if (!Array.isArray(battingOrder) || battingOrder.length < 3) {
            return [];
        }

        const normalizeIndex = (position) => {
            const len = battingOrder.length;
            const normalized = ((position % len) + len) % len;
            return normalized;
        };

        const getPlayer = (position) => {
            const player = battingOrder[normalizeIndex(position)];
            if (player && player.name) return player;
            return battingOrder.find((p) => p && p.name) || { name: '' };
        };

        return [
            [getPlayer(idx)],
            [getPlayer(idx + 1)],
            [getPlayer(idx + 2)]
        ];
    }
    
    try {
    return (
        <>
            {loading ? (<><h1 className="loading">Loading Game...</h1><NavBar teamName={teamName}/></>) : (
            <>
                {lineupToggle && <EditLineup lineupToggle={lineupToggle} setLineupToggle={setLineupToggle} handleLineupForm={handleLineupForm} allPlayers={allPlayers} lineupCards={lineupCards} setLineupCards={setLineupCards} removePlayerFromFunctions={[setRbis, setGameStats, setAverage]} />}
                {popupToggle && <SubmitStats popupToggle={popupToggle} setPopupToggle={setPopupToggle} setSecret={setSecret} secret={secret} setOpponentTeamName={setOpponentTeamName} handleSubmitStatsForm={handleSubmitStatsForm} setGameType={setGameType} gameType={gameType} setForceOutcome={setForceOutcome} forceOutcome={forceOutcome} saveGameResult={saveGameResult}/>}
                <NavBar teamName={teamName}/>
                <Container className={`${lineupToggle ? "blurred" : ""}`}>
                    <Row xs={12} className='mb-1'>
                        <Col className='isInlineGrid'>
                            <ButtonGroup>
                                <Button onClick={() => Globals.toggleCB(setLineupToggle)} className={validBattingOrder.length < 3 ? 'w-100' : 'w-50 whiteBorder'} disabled={gameHasStarted} title={gameHasStarted ? 'Lineup locked after the game starts' : ''}>Lineup</Button>
                                { validBattingOrder.length >= 3 &&
                                    <Button className='w-50 whiteBorder' variant='success' onClick={()=> Globals.toggleCB(setPopupToggle)}>Submit Stats</Button>
                                }
                            </ButtonGroup>
                        </Col>
                    </Row>
                    <Row className='mb-2'>
                        { validBattingOrder.length >= 3 &&
                            <Col xs={12}>
                                <ListGroup horizontal className='my-1'>
                                    <ListGroup.Item id='ourScore' className='vertical-align:middle'>Us: {ourScore}</ListGroup.Item>
                                    <ListGroup.Item id='theirScore'>
                                        <Row>
                                            <Col>
                                                <span className='me-1 vertical-align:middle'>Them: {theirScore}</span>
                                            </Col>
                                            <Col className='px-0'>
                                                <ButtonGroup size="sm">
                                                    <Button id='addEnemyScore' onClick={() => setTheirScore(prev => prev + 1)}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" variant="success" width="16" height="16" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                                                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                                                        </svg>
                                                    </Button>
                                                    <Button id='subEnemyScore' onClick={() => setTheirScore(prev => prev === 0 ? 0 : prev - 1)}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-dash" viewBox="0 0 16 16">
                                                            <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"/>
                                                        </svg>
                                                    </Button>
                                                </ButtonGroup>
                                            </Col>
                                        </Row>
                                    </ListGroup.Item>
                                </ListGroup>                            
                            </Col>
                        }
                    </Row>
                    <Row id="currentBatterRow" className='mb-2'>
                        { validBattingOrder.length >= 3  && 
                            <Col className="currentBatterNav">
                                <svg xmlns="http://www.w3.org/2000/svg" onClick={goToPreviousBatter} fill={'currentColor'} className="bi bi-chevron-compact-left goToPreviousBatter" viewBox="5 0 5 16" preserveAspectRatio="none">
                                <path fillRule="evenodd" d="M9.224 1.553a.5.5 0 0 1 .223.67L6.56 8l2.888 5.776a.5.5 0 1 1-.894.448l-3-6a.5.5 0 0 1 0-.448l3-6a.5.5 0 0 1 .67-.223"/>
                                </svg>
                            </Col>
                        }
                        { getNext3Batters(validBattingOrder, safeSelectedPlayerIdx)[0]?.map((player) => (
                            <Col xs="10" className={`${player === validBattingOrder[safeSelectedPlayerIdx] ? "selected" : ""}`} key={'selected_' + selectedPlayerIdx}>
                                <label className={`${player === validBattingOrder[safeSelectedPlayerIdx] ? "selectedPlayer" : "notSelectedPlayer"}`} htmlFor={player.name}>
                                    <ListGroup>
                                        <ListGroup.Item className='lineupListGroupItemTop'>Batter # {(safeSelectedPlayerIdx + 1)}</ListGroup.Item>
                                    </ListGroup>
                                    <ListGroup horizontal>
                                        <ListGroup.Item className='lineupListGroupItem' id="battingPlayersName">{player.name?.substring(0,10)}</ListGroup.Item>
                                        <ListGroup.Item className='lineupListGroupItem' id="battingPlayersAverage">{(average[safeSelectedPlayerIdx] && average[safeSelectedPlayerIdx][0]) || 0}/{(average[safeSelectedPlayerIdx] && average[safeSelectedPlayerIdx][1]) || 0}</ListGroup.Item>
                                        <ListGroup.Item className='lineupListGroupItem' id="battingPlayersRBIs">{(rbis && rbis[safeSelectedPlayerIdx]) || 0} RBIs</ListGroup.Item>
                                    </ListGroup>
                                    <ListGroup> 
                                        <ListGroup.Item className='lineupListGroupItemBottom'>{(gameStats[safeSelectedPlayerIdx] && gameStats[safeSelectedPlayerIdx].length) ? gameStats[safeSelectedPlayerIdx].join(", ") : 'No Bats Yet'}</ListGroup.Item>
                                    </ListGroup>
                                </label>
                            </Col>
                        ))}
                        { validBattingOrder.length >= 3  &&
                            <Col className="currentBatterNav">
                                <svg xmlns="http://www.w3.org/2000/svg" onClick={goToNextBatter} fill={'currentColor'} className="bi bi-chevron-compact-right goToNextBatter" viewBox="6 0 5 16" preserveAspectRatio="none">
                                    <path fillRule="evenodd" d="M6.776 1.553a.5.5 0 0 1 .671.223l3 6a.5.5 0 0 1 0 .448l-3 6a.5.5 0 1 1-.894-.448L9.44 8 6.553 2.224a.5.5 0 0 1 .223-.671"/>
                                </svg>
                            </Col>
                        }
                    </Row>
                    <Row className='mb-2'>
                        <Col xs={{ span: 10, offset: 1 }}>
                            <ListGroup>
                                {getNext3Batters(validBattingOrder, safeSelectedPlayerIdx)[1]?.map((player) => (
                                    <ListGroup.Item key={`OnDeck${player.name}`}><b>Deck: </b>{player.name}</ListGroup.Item>
                                ))}
                                {getNext3Batters(validBattingOrder, safeSelectedPlayerIdx)[2]?.map((player) => (
                                    <ListGroup.Item key={`OnDeck${player.name}`}><b>Hole: </b>{player.name}</ListGroup.Item>
                                ))}
                            </ListGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col className='px-2 isInlineGrid' xs={12} md={11}>
                            { validBattingOrder.length >= 3 && (
                            <>
                                <ButtonGroup className='mb-1'>
                                    <Button className="px-1 buttonGroupLabel whiteBorder" disabled>On Base</Button>
                                    {goodButtons.map((btn, idx) =>
                                        <Button className="px-1 whiteBorder" value={btn.playerOutcomes} key={`goodButton_${idx}`} onClick={handleCompleteBatClick}>{btn.buttonText}</Button>
                                    )}
                                </ButtonGroup>
                                <ButtonGroup className='mb-1'>
                                    <Button className="px-1 buttonGroupLabel whiteBorder" disabled>Points</Button>
                                    <Button className="px-1 whiteBorder btnGroup2Items" value="RBI+" onClick={(e) => handleCompleteBatClick(e, 'add')}>RBI+</Button>
                                    <Button className="px-1 whiteBorder btnGroup2Items" variant="warning" value="RBI-" onClick={(e) => handleCompleteBatClick(e, 'subtract')}>RBI-</Button>
                                </ButtonGroup>
                                <ButtonGroup className='mb-1'>
                                    <Button className="px-1 buttonGroupLabel whiteBorder" disabled>Other</Button>
                                    {badButtons.map((btn, idx) => (
                                        <Button className="px-1 whiteBorder btnGroup3Items" key={`badButton_${idx}`} variant="danger" value={btn} onClick={handleCompleteBatClick}>{btn}</Button>
                                    ))}
                                </ButtonGroup>
                                <ButtonGroup className='mb-0'>
                                    <Button className="delete-Button" variant='warning' onClick={handleDelete}>Delete Stat</Button>
                                </ButtonGroup>
                            </>
                            )}
                        </Col>
                    </Row>
                    {lineupCards.map((player, idx) => (
                        <input key={'radio_' + idx} id={player.name} type="radio" name="selector" className='hidden' value={idx} checked={player?.name === validBattingOrder[safeSelectedPlayerIdx]?.name} onChange={handleRadioChange} />
                    ))}
                </Container>
            </>)}
        </>
    )}
    catch(e){
       console.error(e);
    }
};

export default NewGame;
